export default __webpack_public_path__ + "static/media/postman.02fdd0fe.png";